import LegalLayout from "./LegalLayout";

export default function Datenschutz() {
  return (
    <LegalLayout title="Datenschutz">
      <div data-testid="datenschutz-content" className="space-y-8">
        <section>
          <h2>1. Verantwortlicher</h2>
          <p>
            Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:<br /><br />
            SABA Business Development – Samil Bayazitoglu<br />
            Danziger Str. 18, 74889 Sinsheim<br />
            E-Mail: <a href="mailto:saba@saba-business-development.de">saba@saba-business-development.de</a><br />
            Telefon: <a href="tel:+4915750186769">+49 157 50186769</a>
          </p>
        </section>

        <section>
          <h2>2. Allgemeines zur Datenverarbeitung</h2>
          <p>
            Wir verarbeiten personenbezogene Daten unserer Nutzer grundsätzlich nur, soweit dies zur
            Bereitstellung einer funktionsfähigen Website sowie unserer Leistungen erforderlich ist. Die
            Verarbeitung erfolgt regelmäßig nur nach Einwilligung des Nutzers oder wenn eine
            Rechtsgrundlage dies gestattet (insb. Art. 6 DSGVO).
          </p>
        </section>

        <section>
          <h2>3. Kontaktformular und E-Mail-Kontakt</h2>
          <p>
            Wenn Sie uns über das Kontaktformular oder per E-Mail eine Anfrage senden, werden die von
            Ihnen angegebenen Daten (Name, E-Mail-Adresse, ggf. Telefon, Unternehmen sowie Ihre
            Nachricht) zur Bearbeitung Ihrer Anfrage gespeichert. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b
            DSGVO (Anbahnung/Erfüllung eines Vertrags) bzw. Art. 6 Abs. 1 lit. f DSGVO (berechtigtes
            Interesse an der Bearbeitung). Zur Benachrichtigung über neue Anfragen setzen wir einen
            E-Mail-Dienstleister (Resend) als Auftragsverarbeiter ein. Die Daten werden gelöscht, sobald
            sie für die Zweckerreichung nicht mehr erforderlich sind.
          </p>
        </section>

        <section>
          <h2>4. Hosting</h2>
          <p>
            Diese Website wird bei einem externen Dienstleister gehostet. Die auf dieser Website erfassten
            personenbezogenen Daten werden auf den Servern des Hosters gespeichert. Der Einsatz erfolgt zum
            Zwecke eines sicheren, schnellen und zuverlässigen Bereitstellens unseres Onlineangebots
            (Art. 6 Abs. 1 lit. f DSGVO). Ein Auftragsverarbeitungsvertrag besteht.
          </p>
        </section>

        <section>
          <h2>5. Server-Log-Dateien</h2>
          <p>
            Der Provider der Seiten erhebt und speichert automatisch Informationen in sogenannten
            Server-Log-Dateien, die Ihr Browser automatisch übermittelt (Browsertyp/-version, verwendetes
            Betriebssystem, Referrer-URL, Hostname, Uhrzeit der Serveranfrage, IP-Adresse). Diese Daten
            werden nicht mit anderen Datenquellen zusammengeführt. Grundlage ist Art. 6 Abs. 1 lit. f DSGVO.
          </p>
        </section>

        <section>
          <h2>6. Cookies</h2>
          <p>
            Unsere Website verwendet nur technisch notwendige Cookies, die für den Betrieb der Seite
            erforderlich sind. Diese Cookies richten keinen Schaden an und werden für eine funktionale
            Nutzung benötigt. Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies
            informiert werden und Cookies nur im Einzelfall erlauben.
          </p>
        </section>

        <section>
          <h2>7. Kontaktaufnahme via WhatsApp</h2>
          <p>
            Auf unserer Seite bieten wir die Möglichkeit, uns per WhatsApp zu kontaktieren. Wenn Sie diese
            Funktion nutzen, gelten zusätzlich die Datenschutzbestimmungen von WhatsApp. Wir verarbeiten
            die von Ihnen übermittelten Angaben ausschließlich zur Bearbeitung Ihrer Anfrage
            (Art. 6 Abs. 1 lit. b und f DSGVO).
          </p>
        </section>

        <section>
          <h2>8. Ihre Rechte</h2>
          <p>
            Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten
            personenbezogenen Daten (Art. 15 DSGVO), deren Herkunft und Empfänger sowie den Zweck der
            Datenverarbeitung. Außerdem haben Sie ein Recht auf Berichtigung (Art. 16), Löschung (Art. 17),
            Einschränkung der Verarbeitung (Art. 18), Datenübertragbarkeit (Art. 20) sowie ein
            Widerspruchsrecht (Art. 21). Eine erteilte Einwilligung können Sie jederzeit widerrufen. Hierzu
            sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit an uns wenden.
          </p>
        </section>

        <section>
          <h2>9. Beschwerderecht bei der Aufsichtsbehörde</h2>
          <p>
            Im Falle datenschutzrechtlicher Verstöße steht Ihnen ein Beschwerderecht bei der zuständigen
            Aufsichtsbehörde zu, insbesondere in dem Mitgliedstaat Ihres Aufenthaltsorts, Ihres
            Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes.
          </p>
        </section>

        <section>
          <h2>10. Aktualität</h2>
          <p>
            Diese Datenschutzerklärung ist aktuell gültig. Durch die Weiterentwicklung unserer Website oder
            aufgrund geänderter gesetzlicher bzw. behördlicher Vorgaben kann es notwendig werden, diese
            Datenschutzerklärung anzupassen.
          </p>
        </section>
      </div>
    </LegalLayout>
  );
}
